// Utilitaire pour forcer le rechargement des ressources CSS/JS

export const forceReloadResources = () => {
  // Forcer le rechargement des feuilles de style CSS
  const links = document.querySelectorAll('link[rel="stylesheet"]');
  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (href) {
      const separator = href.includes('?') ? '&' : '?';
      const timestamp = Date.now();
      link.setAttribute('href', `${href}${separator}v=${timestamp}`);
    }
  });

  // Forcer le rechargement des scripts
  const scripts = document.querySelectorAll('script[src]');
  scripts.forEach((script) => {
    const src = script.getAttribute('src');
    if (src && !src.includes('service-worker.js')) {
      const separator = src.includes('?') ? '&' : '?';
      const timestamp = Date.now();
      script.setAttribute('src', `${src}${separator}v=${timestamp}`);
    }
  });
};

// Fonction pour ajouter un paramètre de version à une URL
export const addVersionToUrl = (url: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  const timestamp = Date.now();
  return `${url}${separator}v=${timestamp}`;
}; 